import script from "./AdjuntarInformesModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./AdjuntarInformesModal.vue?vue&type=script&lang=ts&setup=true"

import "./AdjuntarInformesModal.vue?vue&type=style&index=0&id=ff1426b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff1426b4"]])

export default __exports__